import React, { useState } from "react";
import { Box, Button, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    button: {
        marginTop: "20px !important",
        width: "250px",
        fontSize: "14px",
        textAlign: "center",
        textTransform: "none",
        backgroundColor: "#EE6628 !important",
    },
}));

const ChatForm = ({ fields, onSubmit }) => {
    const classes = useStyles();
    const [formData, setFormData] = useState(() =>
        fields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {})
    );
    const [file, setFile] = useState(null);
    const [errors, setErrors] = useState({});

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleFileChange = (event) => {
        const uploadedFile = event.target.files[0];
        if (uploadedFile) {
            setFile(uploadedFile);
            setErrors((prev) => ({ ...prev, file: "" }));
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let newErrors = {};

        fields.forEach((field) => {
            if (field.type !== "file_upload" && !formData[field.name]?.trim()) {
                newErrors[field.name] = `${field.label} is required`;
            }
        });

        if (!file && fields.some((field) => field.type === "file_upload")) {
            newErrors.file = "File is required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        onSubmit({ ...formData, file });
    };

    return (
        <form onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", width: "465px" }}>
                {fields.map((field, index) => (
                    <Box key={index}>
                        {field.type === "text" || field.type === "number" || field.type === "email" ? (
                            <TextField
                                name={field.name}
                                label={field.label}
                                fullWidth
                                required
                                margin="normal"
                                variant="outlined"
                                type={field.type}
                                error={!!errors[field.name]}
                                helperText={errors[field.name] || ""}
                                onChange={handleChange}
                                value={formData[field.name] || ""}
                                sx={{ backgroundColor: "#fff", mt: 1 }}
                            />
                        ) : field.type === "select" ? (
                            <FormControl fullWidth variant="outlined" margin="normal" error={!!errors[field.name]}>
                                <InputLabel>{field.label}</InputLabel>
                                <Select name={field.name} value={formData[field.name]} onChange={handleChange} label={field.label} sx={{ backgroundColor: "#fff" }}>
                                    {field.options.map((option, index) => (
                                        <MenuItem key={index} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {errors[field.name] && <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>{errors[field.name]}</p>}
                            </FormControl>
                        ) : field.type === "file_upload" ? (
                            <>
                                <input type="file" onChange={handleFileChange} accept=".pdf,.docx,.txt" style={{ marginTop: "10px" }} />
                                {errors.file && <p style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>{errors.file}</p>}
                            </>
                        ) : null}
                    </Box>
                ))}
                <Button variant="contained" type="submit" className={classes.button}>
                    Submit
                </Button>
            </Box>
        </form>
    );
};

export default ChatForm;
